// Координаты ПК на плане зала (grid-row / grid-column для CSS Grid).
// Один зал — подписи зон не нужны.
const floorMap = {
    1: [1, 6], 2: [1, 7], 3: [1, 8], 4: [1, 9], 5: [1, 10], 6: [1, 11], 7: [1, 12], 8: [1, 13], 9: [1, 14],

    10: [3, 7], 11: [3, 8], 12: [3, 9], 13: [3, 10], 14: [3, 11], 15: [3, 12], 16: [3, 13], 17: [3, 14],

    18: [4, 7], 19: [4, 8], 20: [4, 9], 21: [4, 11], 22: [4, 12], 23: [4, 13], 24: [4, 14],

    25: [6, 5], 26: [6, 6], 27: [6, 7], 28: [6, 8], 29: [6, 9], 30: [6, 10], 31: [6, 11], 32: [6, 12], 33: [6, 13], 34: [6, 14],

    35: [7, 5], 36: [7, 6], 37: [7, 7], 38: [7, 8], 39: [7, 9], 40: [7, 10], 41: [7, 11], 42: [7, 12], 43: [7, 13], 44: [7, 14],

    45: [9, 1], 46: [9, 2], 47: [9, 3], 48: [9, 4], 49: [9, 5], 50: [9, 6], 51: [9, 7],
    52: [9, 8], 53: [9, 9], 54: [9, 10], 55: [9, 11], 56: [9, 12], 57: [9, 13], 58: [9, 14],
};

// В этом клубе один зал — подписи зон не нужны.
export const zoneLabels = [];
export const subLabels = [];

export default floorMap;
